var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-header container"},[_c('back-button')],1),_c('post-single',{staticClass:"container",attrs:{"post":_vm.post}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }